/* eslint-disable no-magic-numbers */
/* eslint-disable react/jsx-pascal-case */
import { Themed, useThemeUI } from 'theme-ui'
import { Fragment } from 'react'
import Pagination from '../../elements/pagination'
import { useDataSelector, useComponentMeta } from '@uswitch/ev-utils/lib/context/selectors'
import loadable from '@loadable/component'
import { path } from '@uswitch/ev-utils/lib/obj'
import CategoryGuideCard from '../../compounds/category-guide-card'
import { Col, Row } from '@uswitch/ev-core/react'
import { useCategoryGuides } from './use-category-guides'
import { categoryGuidesStylePath } from './index'

const Carousel = loadable(() => import('../carousel'))

const DefaultCategoryGuides = ({
  variant,
  className = '',
  guides = [],
  layout = 'default',
  title,
  numberOfGuides,
  sys = {},
  showDate,
  showViewAll,
  showPagination = true,
}) => {
  const filteredGuides = useCategoryGuides({ guides })
  const { href } = useDataSelector(['url'])
  const { pathname } = useDataSelector(['location'])
  const { total } = sys
  const limit = useDataSelector(['meta', 'paginationLimit'], 12)

  const { theme } = useThemeUI()
  const guideCardMeta = useComponentMeta('guideCard')
  const cardVariant = variant || guideCardMeta.variant
  const itemsPerRow =
    path(['compounds', 'card', 'variants', cardVariant, 'itemsPerRow'], theme) ||
    path(['compounds', 'card', 'itemsPerRow'], theme)
  const [colsMobile, colsTablet, colsDesktop] = guideCardMeta?.carouselColumns || [2, 2, 2]
  const isDefault = layout === 'default'
  const isCarousel = layout === 'carousel'

  const queryParamString = href.split('?')[1]
  const params = new URLSearchParams(queryParamString)
  const queryPage = params.get('page') || ''
  const showingAllGuides = queryPage === '-1'
  const paginationLimit = Math.min(numberOfGuides, limit) || limit

  return (
    <Fragment>
      <If condition={title}>
        <Themed.h3
          sx={{
            variant: categoryGuidesStylePath('title'),
            color: 'dark-2',
          }}
          className={className}
        >
          {title}
        </Themed.h3>
      </If>
      <Choose>
        <When condition={isCarousel}>
          <Carousel
            sys={sys}
            colsDesktop={colsDesktop}
            colsMobile={colsMobile}
            colsTablet={colsTablet}
            categoryGuides={filteredGuides}
            variant={cardVariant}
            showDate={showDate}
            showSimpleCard={showingAllGuides}
          >
            <For index='key' each='url' of={filteredGuides}>
              <CategoryGuideCard
                guide={url}
                variant={cardVariant}
                showDate={showDate}
                showSimpleCard={showingAllGuides}
              />
            </For>
          </Carousel>
        </When>
        <Otherwise>
          <Row cols={itemsPerRow} wrap>
            <For index='key' each='url' of={filteredGuides}>
              <Col span={1} key={key} sx={{ variant: categoryGuidesStylePath('column') }}>
                <CategoryGuideCard
                  guide={url}
                  variant={cardVariant}
                  showDate={showDate}
                  showSimpleCard={showingAllGuides}
                />
              </Col>
            </For>
          </Row>
        </Otherwise>
      </Choose>

      <If condition={total && isDefault && !showingAllGuides}>
        <div sx={{ display: 'flex', justifyContent: 'center', my: 'sm' }}>
          <If condition={showPagination}>
            <Pagination total={total} limit={paginationLimit} />
          </If>

          <If condition={showViewAll && total > paginationLimit}>
            <a href={`${pathname}?page=-1`} sx={{ margin: 'auto 0', color: 'grey-80' }}>
              View All
            </a>
          </If>
        </div>
      </If>
    </Fragment>
  )
}

export default DefaultCategoryGuides
